import $ from 'jquery'

export default () => {
    const nodeSelectors = {
        container: '[js-cost-calculator="container"]'
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        initCostCalculator()
    }

    function initCostCalculator() {
            // === SLIDER LABEL UPDATES ===
            $('.slider').each(function () {
                const $slider = $(this);
                const $parent = $slider.closest('.input-holder');
                const $labelSpan = $parent.find('.range-label span');
                const $labelOptions = $parent.find('.range-labels span');
                const min = Number($slider.attr('min'));
                const max = Number($slider.attr('max'));
                const canMapToLabels = $labelOptions.length === (max - min + 1);

                const updateLabel = () => {
                    const val = Number($slider.val());
                    if (canMapToLabels) {
                        const idx = val - min;
                        const labelText = $labelOptions.eq(idx).text() || val;
                        $labelSpan.text(labelText);
                    } else {
                        $labelSpan.text(val);
                    }
                };

                updateLabel();
                $slider.on('input', updateLabel);
            });

            // === COST CALCULATOR LOGIC ===
            $('#estimateBtn').on('click', function () {
                const values = $('.slider').map(function () {
                    return Number($(this).val());
                }).get();
                const [jobType, workers, category] = values;

                const $popupOverlay = $('.popup-overlay').fadeIn();

                // JOB, SIZE, CATEGORY(detimening price rate) multipliers
                const jobTypeMultiplier = jobType === 1 ? 1.3 : jobType === 2 ? 1.1 : 1;
                const wordkersSizeMultiplier = workers === 1 ? 1.2 : workers === 2 ? 1.15 : 1.1;

                //this mulliptlier is acytally base price per hour
                const categoryMultiplier = category === 1 ? 6.78 : category === 2 ? 6.12 : 5.79;

                // workidng country multiplier (croatia or serbia)
                const workingCountry = $('input[name="workingCountry"]:checked').val();
                const workingCountryMultiplier = workingCountry === 'croatia' ? 1.25 : 1;
                
                // base rate calculated with all multipliers
                const baseRate = categoryMultiplier * jobTypeMultiplier * wordkersSizeMultiplier * workingCountryMultiplier

                // Calculations
                const workersSize = workers === 1 ? 10 : workers === 2 ? 50 : 100;
                // const monthlyHours = workersSize * 160; // assuming 160 hours per worker per month
                const monthlyHours = 176; // assuming 160 hours per worker per month
                const monthlyExpenses = monthlyHours * baseRate;
                const grossPerHour = monthlyExpenses / monthlyHours;

                // === POPUP FILL ===
                $('#monthlyHours').text(monthlyHours.toLocaleString());
                $('#monthlyExpenses').text(`$${monthlyExpenses.toLocaleString(undefined, { maximumFractionDigits: 0 })}`);
                $('#grossPerHour').text(`$${grossPerHour.toFixed(2)}/hr`);

                // === SHOW POPUP ===
                const $popup = $('.results-popup').fadeIn().css({ display: 'flex' });
            });

            // === CLOSE POPUP ===
            $('.closePopup').on('click', function () {
                const $popup = $('.results-popup');
                const $formPopup = $('.results-form');
                $popup.fadeOut();
                $formPopup.fadeOut();

                $('.popup-overlay').fadeOut();
            });

            // === OPEN POPUP FORM ===
            $('#getquotebtn').on('click', function () {
                $('.results-form').fadeIn().css({ display: 'flex' });
            });
        // });
        
    }

    return Object.freeze({
        init,
    })
}